var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewMobileEmulator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 590,
    viewBox: "0 0 330 590",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3798_52737)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3798_52737)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 13,
    width: 296,
    height: 556,
    rx: 34,
    fill: "#F2F5F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 13,
    width: 296,
    height: 556,
    rx: 34,
    stroke: "#0B0704",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 47C19 29.3269 33.3269 15 51 15H279C296.673 15 311 29.3269 311 47V49H19V47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6596 26.9205C42.1656 26.9205 42.6221 27.0415 43.0291 27.2835C43.4361 27.5255 43.7588 27.8555 43.9971 28.2735C44.2391 28.6915 44.3601 29.1663 44.3601 29.698V32.3325C44.3601 32.8862 44.241 33.3757 44.0026 33.801C43.7643 34.2263 43.4343 34.56 43.0126 34.802C42.5946 35.044 42.1143 35.165 41.5716 35.165C41.139 35.165 40.7338 35.0752 40.3561 34.8955C39.9821 34.7158 39.665 34.461 39.4046 34.131L40.1361 33.482C40.2975 33.7093 40.5046 33.8927 40.7576 34.032C41.0106 34.1677 41.282 34.2355 41.5716 34.2355C41.9236 34.2355 42.2335 34.1512 42.5011 33.9825C42.7725 33.8138 42.9833 33.5938 43.1336 33.3225C43.2876 33.0512 43.3646 32.7578 43.3646 32.4425V30.853L43.5791 31.095C43.3518 31.425 43.0603 31.689 42.7046 31.887C42.349 32.085 41.9621 32.184 41.5441 32.184C41.0528 32.184 40.6128 32.0685 40.2241 31.8375C39.8355 31.6065 39.5275 31.2948 39.3001 30.9025C39.0728 30.5065 38.9591 30.0628 38.9591 29.5715C38.9591 29.0802 39.082 28.6347 39.3276 28.235C39.5733 27.8317 39.8996 27.5127 40.3066 27.278C40.7173 27.0397 41.1683 26.9205 41.6596 26.9205ZM41.6596 27.8665C41.3443 27.8665 41.0565 27.9435 40.7961 28.0975C40.5395 28.2478 40.3341 28.4532 40.1801 28.7135C40.0261 28.9702 39.9491 29.2562 39.9491 29.5715C39.9491 29.8868 40.0243 30.1747 40.1746 30.435C40.3286 30.6917 40.534 30.897 40.7906 31.051C41.051 31.205 41.3388 31.282 41.6541 31.282C41.9695 31.282 42.2573 31.205 42.5176 31.051C42.778 30.897 42.9833 30.6917 43.1336 30.435C43.2876 30.1747 43.3646 29.8868 43.3646 29.5715C43.3646 29.2598 43.2876 28.9757 43.1336 28.719C42.9833 28.4587 42.778 28.2515 42.5176 28.0975C42.261 27.9435 41.975 27.8665 41.6596 27.8665ZM46.0412 34.175V33.097H47.1192V34.175H46.0412ZM46.0467 30.963V29.885H47.1247V30.963H46.0467ZM52.1704 35V33.5425H48.5294V32.613L51.1419 27.08H52.2529L49.6404 32.613H52.1704V30.3855H53.1604V32.613H53.9854V33.5425H53.1604V35H52.1704ZM56.3826 35V28.1635L54.8921 29.0655V27.971L56.3826 27.08H57.3781V35H56.3826Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.35,
    x: 275.132,
    y: 26.5,
    width: 14.3995,
    height: 6.93306,
    rx: 2.16667,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M290.731 28.5664V31.3663C291.295 31.1292 291.661 30.5775 291.661 29.9664C291.661 29.3552 291.295 28.8035 290.731 28.5664",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.032,
    y: 27.4004,
    width: 12.5996,
    height: 5.13316,
    rx: 1.33333,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.766 27.5991C267.323 27.5991 268.821 28.197 269.95 29.2691C270.035 29.3518 270.171 29.3508 270.254 29.2667L271.067 28.4475C271.109 28.4049 271.133 28.3471 271.132 28.2871C271.132 28.227 271.108 28.1695 271.065 28.1273C268.103 25.2909 263.429 25.2909 260.467 28.1273C260.424 28.1695 260.4 28.2269 260.399 28.287C260.399 28.3471 260.423 28.4049 260.465 28.4475L261.278 29.2667C261.361 29.3509 261.497 29.352 261.582 29.2691C262.711 28.1969 264.209 27.5991 265.766 27.5991ZM265.766 30.2643C266.622 30.2642 267.447 30.582 268.081 31.1558C268.167 31.2373 268.302 31.2355 268.386 31.1518L269.197 30.3326C269.24 30.2897 269.263 30.2314 269.263 30.1708C269.262 30.1102 269.237 30.0524 269.194 30.0103C267.262 28.2153 264.271 28.2153 262.34 30.0103C262.296 30.0524 262.272 30.1103 262.271 30.1709C262.27 30.2315 262.294 30.2897 262.337 30.3326L263.148 31.1518C263.232 31.2355 263.367 31.2373 263.453 31.1558C264.087 30.5824 264.911 30.2647 265.766 30.2643ZM267.392 32.0575C267.393 32.1182 267.369 32.1768 267.326 32.2194L265.922 33.6347C265.881 33.6763 265.825 33.6997 265.766 33.6997C265.708 33.6997 265.652 33.6763 265.61 33.6347L264.206 32.2194C264.163 32.1768 264.139 32.1182 264.141 32.0574C264.142 31.9967 264.168 31.9392 264.213 31.8985C265.11 31.1409 266.423 31.1409 267.319 31.8985C267.364 31.9392 267.39 31.9968 267.392 32.0575Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.2 26H255.5C255.113 26 254.8 26.3134 254.8 26.7V32.7664C254.8 33.153 255.113 33.4664 255.5 33.4664H256.2C256.586 33.4664 256.9 33.153 256.9 32.7664V26.7C256.9 26.3134 256.586 26 256.2 26ZM252.233 27.6328H252.933C253.32 27.6328 253.633 27.9462 253.633 28.3328V32.766C253.633 33.1526 253.32 33.4659 252.933 33.4659H252.233C251.846 33.4659 251.533 33.1526 251.533 32.766V28.3328C251.533 27.9462 251.846 27.6328 252.233 27.6328ZM249.667 29.2656H248.967C248.58 29.2656 248.267 29.579 248.267 29.9656V32.7655C248.267 33.1521 248.58 33.4655 248.967 33.4655H249.667C250.053 33.4655 250.367 33.1521 250.367 32.7655V29.9656C250.367 29.579 250.053 29.2656 249.667 29.2656ZM246.4 30.666H245.7C245.313 30.666 245 30.9794 245 31.366V32.7659C245 33.1525 245.313 33.4659 245.7 33.4659H246.4C246.787 33.4659 247.1 33.1525 247.1 32.7659V31.366C247.1 30.9794 246.787 30.666 246.4 30.666Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 19,
    width: 78,
    height: 22,
    rx: 11,
    fill: "#040200"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 9.5,
    width: 303,
    height: 563,
    rx: 37.5,
    stroke: "#C7C3BE",
    strokeWidth: 3,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3798_52737",
    x: 0,
    y: 0,
    width: 330,
    height: 590,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3798_52737"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3798_52737",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3798_52737"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 11,
    width: 300,
    height: 560,
    rx: 36,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMobileEmulator);
export default __webpack_public_path__ + "static/media/newMobileEmulator.7d103ddda01095957811b7916b44fb9e.svg";
export { ForwardRef as ReactComponent };